import * as React from 'react';
import { Field } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';

interface Props {
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  postcode: string | null;
}

const isNotEmpty = (str: string | null) => str && str.length > 0;

export const AddressTextBox = ({ addressLine1, addressLine2, city, state, country, postcode }: Props) => {
  const formatCityStateAndZip = () => {
    if (city && state) {
      return postcode ? `${city}, ${state} ${postcode}` : `${city}, ${state}`;
    }

    return [city, state, postcode].filter(isNotEmpty).join(' ');
  };

  const formattedCityStateAndZip = formatCityStateAndZip();
  const addressLines = [addressLine1, addressLine2, formattedCityStateAndZip, country]
    .filter(isNotEmpty)
    .reduce((accumulator, addressLine) => accumulator + `\n${addressLine}`);

  return (
    <Field label="Address" name="address" defaultValue={addressLines}>
      {({ fieldProps }: any) => <TextArea {...fieldProps} isReadOnly />}
    </Field>
  );
};

export default AddressTextBox;
